import ajax from './axios'



export const getvisitdata = (params) => {
  return ajax.get('/api/v2/ip/show/form')
}

export const getvisitmap = (params) => {
    return ajax.get('/api/v2/ip/show/line_chart?fre=weekly')
  }



// WEBPACK FOOTER //
// ./src/api/visit.js